import React from "react";
import { Helmet } from "react-helmet";

import { companyInfo, defaultKeywords, siteUrl } from "../../data/siteContent";

export default function SEO({
  title,
  description,
  path = "/",
  image = companyInfo.logo,
  keywords = [],
}) {
  const pageTitle = title ? `${title} | ${companyInfo.name}` : companyInfo.name;
  const pageDescription = description || companyInfo.description;
  const pageUrl = `${siteUrl}${path}`;
  const imageUrl = image.startsWith("http") ? image : `${siteUrl}${image}`;
  const keywordContent = [...new Set([...defaultKeywords, ...keywords])].join(", ");

  const structuredData = [
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: companyInfo.name,
      url: siteUrl,
      logo: `${siteUrl}${companyInfo.logo}`,
      email: companyInfo.email,
      telephone: companyInfo.primaryPhone,
      address: {
        "@type": "PostalAddress",
        streetAddress: companyInfo.addressLines[0],
        addressLocality: "Sathyamangalam",
        addressRegion: "Tamil Nadu",
        postalCode: "638402",
        addressCountry: "IN",
      },
      sameAs: companyInfo.socialLinks.map((link) => link.href),
    },
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: companyInfo.name,
      url: siteUrl,
      description: companyInfo.description,
    },
  ];

  return (
    <Helmet>
      <html lang="en" />
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <meta name="keywords" content={keywordContent} />
      <meta name="robots" content="index, follow" />
      <meta name="theme-color" content="#0b4c33" />
      <link rel="canonical" href={pageUrl} />

      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:image" content={imageUrl} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={imageUrl} />

      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
}
